import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { EditorFeatureConfigSymbol, Props } from '@wix/thunderbolt-symbols'
import type { IPropsStore } from '@wix/thunderbolt-symbols'
import type { CustomCssEditorConfig, ICustomCssAPI } from '../types'
import { name } from '../symbols'
import { fetchStyles, getInstance } from '../customCss'
import { SessionManagerSymbol } from 'feature-session-manager'
import type { ISessionManager } from 'feature-session-manager'
import { getPageCssDev as getPageCss } from '@wix/ambassador-velo-css-v1-page-css/http'
import { ViewEnvironment } from '../constants'

export const CustomCssAPI = withDependencies(
	[named(EditorFeatureConfigSymbol, name), Props, SessionManagerSymbol],
	(siteFeatureConfig: CustomCssEditorConfig, props: IPropsStore, sessionManager: ISessionManager): ICustomCssAPI => {
		return {
			refreshCustomStyles: async () => {
				const customCSS = await fetchStyles(
					siteFeatureConfig.gridAppId,
					siteFeatureConfig.isPreview ? ViewEnvironment.PREVIEW : ViewEnvironment.EDITOR,
					getInstance(sessionManager.getAppInstanceByAppDefId),
					getPageCss
				)
				if (customCSS) {
					props.update({
						CUSTOM_CSS: { css: customCSS },
					})
				}
			},
		}
	}
)
